import _isEmpty from "ramda/es/isEmpty";
import _isNil from "ramda/es/isNil";
import _either from "ramda/es/either";
export default _either(_isNil, _isEmpty);